/*
 * @Description:
 * @Date: 2025-06-12 17:07:16
 */
import http from '@/utils/http/axios';
import {
  pagerTranslator,
  pickerTranslator,
  map2ArrTranslator
} from '@data-source/common/translators';
import {
  NotInvoicedList,
  SummarizeTheInvoiceInformation,
  BasicInformation,
  InvoiceInformationEditing,
  InvoicePostalAddressEditor,
  ObtainTheSeller,
  MakeOutAnInvoice,
  InvoiceCategory,
  DeleteInvoiceCate,
  EditInvoiceCate,
  ModifyIndustry,
  NotInvoicedListUserInfo,
  ContentOfMakeOutAnInvoice,
  MakeOutAnInvoiceDk,
  QueryInvoiceList,
  InvoiceDetail,
  Recognition,
  AuditInvoice,
  SaveInvoice,
  RedInvoice,
  ListSelectEnterprise,
  IndustryListInvoice,
  IndustryDetail,
  IndustryAddInvoiceApply,
  OpenReject,
  QueryInvoicePeopleList,
  SelectParkList,
  Download2Center,
  QueryInvoiceOrder,
  ListSupplier,
  GyDownloadBatch,
  ListProxyTax,
  ListPark,
  DownloadProxyTaxBatchFile,
  DownInvoiceProxyTaxDTO,
  AddProxyTax,
  DeleteProxyTax,
  ProxyTaxFile
} from './types';
import {
  notInvoicedListTranslator,
  contentOfMakeOutAnInvoiceTranslator,
  listSelectEnterpriseTranslator,
  listSupplierTranslator,
  queryInvoiceListParamsTranslator,
  recognitiontranslator
} from './translators';

enum Api {
  notInvoicedList = '/front-end/invoice/fe/notInvoicedList', // 未开票订单-列表
  notInvoicedListUserInfo = '/front-end/invoice/fe/notInvoicedListUserInfo', // 委托代开-未开票订单人员明细
  summarizeTheInvoiceInformation = '/front-end/invoice/fe/summarizeTheInvoiceInformation', // 发票信息-汇总
  basicInformation = '/front-end/invoice/fe/basicInformation', // 企业开票信息
  invoiceInformationEditing = '/front-end/invoice/fe/invoiceInformationEditing', // 开票信息编辑
  invoicePostalAddressEditor = '/front-end/invoice/fe/invoicePostalAddressEditor', // 邮寄地址编辑
  obtainTheSeller = '/front-end/invoice/fe/obtainTheSeller', // 获取销方信息
  makeOutAnInvoice = '/front-end/invoice/fe/makeOutAnInvoice', // 开票
  invoiceCategory = '/front-end/invoice/fe/invoiceCategory', // 新增接口
  deleteInvoiceCate = '/front-end/invoice/service/api/v1/deleteInvoiceCate', // 删除发票类目接口
  editInvoiceCate = '/front-end/invoice/service/api/v1/editInvoiceCate', // 删除发票类目接口
  modifyIndustry = '/front-end/invoice/industry/api/v1/modifyIndustry', // 发票维护--修改工业企业信息维护信息
  contentOfMakeOutAnInvoice = '/front-end/invoice/fe/contentOfMakeOutAnInvoice', // 委托代开-未开票订单人员明细-人分组
  makeOutAnInvoiceDk = '/front-end/invoice/fe/makeOutAnInvoiceDk', // 开票-委托代开
  queryInvoiceList = '/front-end/invoice/service/api/v1/queryInvoiceList', // 开票记录-列表
  listAsp = '/front-end/invoice/service/api/v1/listAsp', // 开票记录--购买方(下拉框)
  listSupplier = '/front-end/invoice/service/api/v1/listSupplier', // 开票记录--销售方(下拉框)
  jlBatchDownload = '/front-end/invoice/service/api/v1/batchDownload', // 开票记录-批量下载
  invoiceType = '/front-end/invoice/service/api/v1/invoiceType', // 订单类型，根据当前职能返回对应！订单类型！，与ORDER_TYPE类型一致
  invoiceDetail = '/front-end/invoice/service/api/v1/invoiceDetail', // 开票记录-详情
  recognition = '/front-end/invoice/service/api/v1/recognition', // 发票识别
  logisticsCode = '/front-end/invoice/service/api/v1/logisticsCode', // 物流公司
  auditInvoice = '/front-end/invoice/service/api/v1/auditInvoice', // 审核发票
  saveInvoice = '/front-end/invoice/service/api/v1/saveInvoice', // 上传发票
  redInvoice = '/front-end/invoice/service/api/v1/redInvoice', // 红冲按钮 <p> 提出红冲申请
  invoiceExport = '/front-end/invoice/service/api/v1/invoiceExport', // 下载开票信息
  listSelectEnterprise = '/front-end/invoice/industry/api/v1/listSelectEnterprise', // 下拉框企业名称
  industryListInvoice = '/front-end/invoice/industry/api/v1/listInvoice', // 工业发票列表
  industryDetail = '/front-end/invoice/industry/api/v1/detail', // 工业发票详情
  industryAddInvoiceApply = '/front-end/invoice/industry/api/v1/addInvoiceApply', // 工业发票-发票申请（包含新增或者编辑）
  industryGetCsoInvoiceCate = '/front-end/invoice/industry/api/v1/getCsoInvoiceCate', // 工业发票-获取开票类目
  listSelectASP = '/front-end/invoice/industry/api/v1/listSelectASP', // 工业职能 销售方列表
  gyDownloadBatch = '/front-end/invoice/industry/api/v1/downloadBatch', // 批量下载发票（走下载中心下载 --企业发票（工业发票））
  openReject = '/front-end/invoice/service/api/v1/reject', // 驳回申请开票
  queryInvoicePeopleList = '/front-end/invoice/service/api/v1/queryInvoicePeopleList', // 开票记录--详情--园区个体发票记录详情
  selectParkList = '/front-end/proofFe/asp/parkTaxPayment/selectParkList', // 服务商职能 个体完税证明 - 查询个体列表
  download2Center = '/front-end/invoice/service/api/v1/download', // 下载开票信息-到下载中心，目前老个体使用
  queryInvoiceOrder = '/front-end/invoice/service/api/v1/queryInvoiceOrder', // 发票金额 价税合计接口
  // 代缴税金
  listProxyTax = '/front-end/invoice/proxyTax/api/v1/listProxyTax', // 获取 代缴税金列表
  listPark = '/front-end/invoice/proxyTax/api/v1/listPark', // 下拉框 OSS的话获取所有的的园区
  downloadBatchFile = '/front-end/invoice/proxyTax/api/v1/downloadBatchFile', // 批量下载代缴税金记录对应的相关附件信息（走下载中心下载 --代缴税金）
  proxyTaxListExport = '/front-end/invoice/proxyTax/api/v1/downloadBatchData', // 批量下载代缴税金记录对应的相关列表显示的字段（不走下载中心 直接返回文件）
  addProxyTax = '/front-end/invoice/proxyTax/api/v1/addProxyTax', // 新增代缴税金
  deleteProxyTax = '/front-end/invoice/proxyTax/api/v1/deleteProxyTax', // 删除代缴税金记录
  proxyTaxFile = '/front-end/invoice/proxyTax/api/v1/proxyTaxFile' // 上传代缴税金及附件
}

const yApiObj = {
  // yapi: 1263
};

export const notInvoicedList: NotInvoicedList = async params => {
  const resp = await http.request(
    {
      url: Api.notInvoicedList,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return notInvoicedListTranslator(pagerTranslator(resp));
};

/**
 * 委托代开-未开票订单人员明细
 * @param params
 */
export const notInvoicedListUserInfo: NotInvoicedListUserInfo =
  async params => {
    const resp = await http.request(
      {
        url: Api.notInvoicedListUserInfo,
        method: 'POST',
        params
      },
      {
        ...yApiObj
      }
    );
    return pagerTranslator(resp);
  };
export const summarizeTheInvoiceInformation: SummarizeTheInvoiceInformation =
  () =>
    http.request(
      {
        url: Api.summarizeTheInvoiceInformation,
        method: 'POST'
      },
      {
        ...yApiObj
      }
    );
export const basicInformation: BasicInformation = () =>
  http.request(
    {
      url: Api.basicInformation,
      method: 'POST'
    },
    {
      ...yApiObj
    }
  );
export const invoiceInformationEditing: InvoiceInformationEditing = params =>
  http.request(
    {
      url: Api.invoiceInformationEditing,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
export const invoicePostalAddressEditor: InvoicePostalAddressEditor = params =>
  http.request(
    {
      url: Api.invoicePostalAddressEditor,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 获取销方信息
 * @param params
 */
export const obtainTheSeller: ObtainTheSeller = params =>
  http.request(
    {
      url: Api.obtainTheSeller,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 开票
 * @param params
 */
export const makeOutAnInvoice: MakeOutAnInvoice = params =>
  http.request(
    {
      url: Api.makeOutAnInvoice,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 新增接口：发票类目
 * @param params
 */
export const invoiceCategory: InvoiceCategory = params =>
  http.request(
    {
      url: Api.invoiceCategory,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 删除发票类目
 * @param params
 */
export const deleteInvoiceCate: DeleteInvoiceCate = params =>
  http.request(
    {
      url: Api.deleteInvoiceCate,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
export const editInvoiceCate: EditInvoiceCate = params =>
  http.request(
    {
      url: Api.editInvoiceCate,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 修改工业发票信息
 * @param params
 */
export const modifyIndustry: ModifyIndustry = params =>
  http.request(
    {
      url: Api.modifyIndustry,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 委托代开-未开票订单人员明细-人分组
 * @param params
 */
export const contentOfMakeOutAnInvoice: ContentOfMakeOutAnInvoice =
  async params => {
    const resp = await http.request(
      {
        url: Api.contentOfMakeOutAnInvoice,
        method: 'POST',
        params
      },
      {
        ...yApiObj
      }
    );
    return contentOfMakeOutAnInvoiceTranslator(pagerTranslator(resp));
  };

/**
 * 开票-委托代开
 * @param params
 */
export const makeOutAnInvoiceDk: MakeOutAnInvoiceDk = params =>
  http.request(
    {
      url: Api.makeOutAnInvoiceDk,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 开票记录-列表
 * @param params
 */
export const queryInvoiceList: QueryInvoiceList = params =>
  http.request(
    {
      url: Api.queryInvoiceList,
      method: 'POST',
      params: queryInvoiceListParamsTranslator(params)
    },
    {
      ...yApiObj
    }
  );

/**
 * 开票记录-详情
 * @param params
 */
export const invoiceDetail: InvoiceDetail = async params => {
  const resp = await http.request(
    {
      url: Api.invoiceDetail,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return resp;
};

/**
 * 发票识别
 * @param params
 */
export const recognition: Recognition = async params => {
  const resp = await http.request(
    {
      url: Api.recognition,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
  return recognitiontranslator(resp);
};

export const listAsp = async params => {
  const resp = await http.request(
    {
      url: Api.listAsp,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return pickerTranslator(resp);
};

export const listSupplier: ListSupplier = async params => {
  const resp = await http.request(
    {
      url: Api.listSupplier,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

  return listSupplierTranslator(resp);
};
export const invoiceType = async () => {
  const resp = await http.request(
    {
      url: Api.invoiceType,
      method: 'GET'
    },
    {
      ...yApiObj
    }
  );
  return map2ArrTranslator(resp);
};
export const logisticsCode = async params => {
  const resp = await http.request(
    {
      url: Api.logisticsCode,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
  return map2ArrTranslator(resp);
};

/**
 * 审核发票
 * @param params
 */
export const auditInvoice: AuditInvoice = async params => {
  const resp = await http.request(
    {
      url: Api.auditInvoice,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return resp;
};

/**
 * 上传发票（发票类型 1 蓝票 2 红票）
 * @param params
 */
export const saveInvoice: SaveInvoice = params =>
  http.request(
    {
      url: Api.saveInvoice,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
export const redInvoice: RedInvoice = params =>
  http.request(
    {
      url: Api.redInvoice,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
export const invoiceExport = (params: { invoiceId: number }) =>
  http.download({
    url: Api.invoiceExport,
    method: 'POST',
    params
  });

/**
 * 下拉框企业名称
 */
export const listSelectEnterprise: ListSelectEnterprise = async params => {
  const resp = await http.request(
    {
      url: Api.listSelectEnterprise,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return listSelectEnterpriseTranslator(resp);
};
export const listSelectASP = async params =>
  http.request(
    {
      url: Api.listSelectASP,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 获取工业发票列表
 */
export const industryListInvoice: IndustryListInvoice = async params =>
  http.request(
    {
      url: Api.industryListInvoice,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 获取工业发票详情
 */
export const industryDetail: IndustryDetail = async params => {
  const resp = await http.request(
    {
      url: Api.industryDetail,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
  return resp;
};
export const industryAddInvoiceApply: IndustryAddInvoiceApply = async params =>
  http.request(
    {
      url: Api.industryAddInvoiceApply,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
export const industryGetCsoInvoiceCate = () =>
  http.request(
    {
      url: Api.industryGetCsoInvoiceCate,
      method: 'POST'
    },
    {
      ...yApiObj
    }
  );
export const openReject: OpenReject = async params =>
  http.request(
    {
      url: Api.openReject,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 开票记录--详情--园区个体发票记录详情
 * @param params
 */
export const queryInvoicePeopleList: QueryInvoicePeopleList = async params =>
  http.request(
    {
      url: Api.queryInvoicePeopleList,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 服务商职能 个体完税证明 - 查询个体列表
 * @param params
 */
export const selectParkList: SelectParkList = async params =>
  http.request(
    {
      url: Api.selectParkList,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
export const download2Center: Download2Center = async params =>
  http.request(
    {
      url: Api.download2Center,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
export const queryInvoiceOrder: QueryInvoiceOrder = async params => {
  const resp = await http.request(
    {
      url: Api.queryInvoiceOrder,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return pagerTranslator(resp);
};
export const gyDownloadBatch: GyDownloadBatch = async params => {
  const resp = await http.request(
    {
      url: Api.gyDownloadBatch,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return resp;
};
export const jlBatchDownload: GyDownloadBatch = async params => {
  const resp = await http.request(
    {
      url: Api.jlBatchDownload,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return resp;
};
export const listProxyTax: ListProxyTax = async params =>
  http.request(
    {
      url: Api.listProxyTax,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
export const listPark: ListPark = async params =>
  http.request(
    {
      url: Api.listPark,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

export const downloadBatchFile: DownloadProxyTaxBatchFile = async params =>
  http.request(
    {
      url: Api.downloadBatchFile,
      method: 'POST',
      params
    },
    { isShowErrorMessage: false, ...yApiObj }
  );
export const proxyTaxListExport = (params: DownInvoiceProxyTaxDTO) =>
  http.download(
    {
      url: Api.proxyTaxListExport,
      method: 'POST',
      params
    },
    {
      isShowSuccessMessage: false,
      ...yApiObj
    }
  );

/**
 * 新增代缴税金
 * @param params
 */
export const addProxyTax: AddProxyTax = async params =>
  http.request(
    {
      url: Api.addProxyTax,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 删除代缴税金记录
 * 状态为待上传的可以进行删除操作
 * @param params
 */
export const deleteProxyTax: DeleteProxyTax = async params =>
  http.request(
    {
      url: Api.deleteProxyTax,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * 上传代缴税金及附件
 * @param params
 */
export const proxyTaxFile: ProxyTaxFile = async params =>
  http.request(
    {
      url: Api.proxyTaxFile,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
